class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


document.addEventListener('DOMContentLoaded', function() {
  const inlineMenu = document.querySelector('.header__inline-menu');
  if (!inlineMenu) return;

  const detailItems = inlineMenu.querySelectorAll('details');

  detailItems.forEach(item => {
    const summary = item.querySelector('summary');

    // Fermer automatiquement les autres menus quand on ouvre celui-ci
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = item.hasAttribute('open');
      detailItems.forEach(i => i.removeAttribute('open'));
      if (!isOpen) item.setAttribute('open', '');
    });
  });
});